// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1ptcO","buttons":"SendReceipts_buttons__3_bI5","email":"SendReceipts_email__19YhC","bookApptTitle":"SendReceipts_bookApptTitle__1uYMu"};